import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { ViewerTopThreadsLoadAction } from '../../domains/viewerTopThreads/actions.types';

import { ViewerTopThreadsLifecycle } from './types';

const initialState: ViewerTopThreadsLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<ViewerTopThreadsLifecycle, ViewerTopThreadsLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'VIEWER_TOP_THREADS.LOAD_PENDING':
      return setPending();
    case 'VIEWER_TOP_THREADS.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.viewerTopThreads);
    case 'VIEWER_TOP_THREADS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
